import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=296c58fd&scoped=true"
import script from "./ProductsSection.vue?vue&type=script&lang=js"
export * from "./ProductsSection.vue?vue&type=script&lang=js"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&id=296c58fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c58fd",
  null
  
)

export default component.exports